import { createContext } from 'react';
import { AuthRequest } from '../auth.interface';
import { RootState } from '@/app/store';

export type AuthContextType = {
  login: (credentials: AuthRequest) => Promise<void>;
  logout: () => Promise<void>;
  user: RootState['auth']['user'];
  isDefault: boolean;
  setIsDefault: (isDefault: boolean) =>void;
  isLoading: boolean;
};

export const AuthContext = createContext<AuthContextType | null>(null);